<template>
  <div class="twui-signup xfind">
    <div class="twui-signup-header">
      <img src="static/dev/images/logo_reg.png" />
    </div>
    <div class="twui-signup-body" :style="{ 'min-height':minHeight }">
      <h2>找回密码</h2>
      <div class="twui-steps xfind">
        <el-steps :active="active">
          <el-step title="填写帐户名" style="width:230px;"></el-step>
          <el-step title="验证身份" style="width:230px;"></el-step>
          <el-step title="设置新密码" style="width:230px;"></el-step>
          <el-step title="完成"></el-step>
        </el-steps>
      </div>
      <!-- 步骤内容区 -->
      <div style="padding-top:20px;">
        <!-- 填写帐户名 -->
        <div v-show="active==1">
          <div class="twui-blocktitle">填写帐户名</div>
          <el-form class="twui-findpwd">
            <el-form-item label="帐户名:" label-width="11em">
              <el-input auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="验证码:" label-width="11em">
              <el-input auto-complete="off" style="width:160px;"></el-input>
              <img style="height:30px;" src="/static/dev/images/code.png" />
              <a class="twui-xlink">&nbsp;&nbsp;获取验证码</a>
            </el-form-item>
            <el-form-item label="请选择验证身份方式:" label-width="11em">
              <el-radio v-model="type" label="phone">手机验证</el-radio>
              <el-radio v-model="type" label="email">邮箱验证</el-radio>
            </el-form-item>
          </el-form>
        </div>
        <!-- /填写帐户名 -->
        <!-- 验证身份 -->
        <div v-show="active==2">
          <div class="twui-blocktitle">验证身份</div>
          <el-form class="twui-findpwd" v-if="type==='phone'">
            <el-form-item label="姓名:" label-width="11em">用户姓名</el-form-item>
            <el-form-item label="已验证手机:" label-width="11em">137****143</el-form-item>
            <el-form-item label="请填写手机验证码:" label-width="11em">
              <el-input auto-complete="off" style="width:160px;"></el-input>
              <a class="twui-xlink">&nbsp;&nbsp;获取验证码</a>
            </el-form-item>
          </el-form>
          <el-form class="twui-findpwd" v-if="type==='email'">
            <el-form-item label="姓名:" label-width="11em">用户姓名</el-form-item>
            <el-form-item label="邮箱:" label-width="11em">137****143</el-form-item>
            <el-form-item label="请填写邮箱验证码:" label-width="11em">
              <el-input auto-complete="off" style="width:160px;"></el-input>
              <a class="twui-xlink">&nbsp;&nbsp;获取验证码</a>
            </el-form-item>
          </el-form>
        </div>
        <!-- /验证身份 -->
        <!-- 填写帐户名 -->
        <div v-show="active==3">
          <div class="twui-blocktitle">设置新密码</div>
          <el-form class="twui-findpwd" style="width:300px;">
            <el-form-item label="新登录密码:" label-width="7em">
              <el-input type="password" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码:" label-width="7em">
              <el-input type="password" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <!-- /填写帐户名 -->
        <!-- 完成 -->
        <div v-show="active==4">
          <div class="twui-blocktitle">完成</div>
          <div style="text-align:center;">
            <div style="display:inline-block; text-align:left;">
              <p class="twui-xhighlight3"><i class="el-icon-check"></i>&nbsp;&nbsp;新密码设置成功!</p>
              <span>请牢记您新设置的密码,<router-link class="twui-xlink" to="/">返回首页</router-link></span>
            </div>
          </div>
        </div>
        <!-- /完成 -->
      </div>
      <!-- /步骤内容区 -->
      <!-- 按钮区 -->
      <div class="twui-btnarea">
        <div class="twui-btnarea-inner">
          <button class="twui-btn xmain xlarge xdisabled" @click="next" v-show="active<3">下一步</button>
          <button class="twui-btn xmain xlarge" @click="next" v-show="active===3">提交</button>
        </div>
      </div>
      <!-- /按钮区 -->
    </div>
    <tw-footer></tw-footer>
  </div>
</template>
<script>
  export default {
    name: 'TwFindPassword',
    data: function () {
      return {
        active: 1,
        minHeight: 0,
        type: 'phone'
      }
    },
    methods: {
      next: function () {
        this.active++
      }
    },
    created: function () {
      this.minHeight = window.innerHeight - 160 + 'px'
    }
  }
</script>



// WEBPACK FOOTER //
// find_password.vue?7f93dda9